import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortenSize'
})
export class ShortenSizePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {

    if (typeof value === 'string') {
      const sizes: { [key: string]: string } = {
        'xx-small': 'XXS',
        'x-small': 'XS',
        'small': 'S',
        'medium': 'M',
        'large': 'L',
        'x-large': 'XL',
        '2x-large': '2XL',
        '3x-large': '3XL',
        '4x-large': '4XL',
        '5x-large': '5XL'
      };

      return sizes[value.toLowerCase()] || value;
    }
    return value;
  }

}
